import React, { Component } from 'react'

import { getProperty } from '../utils'
import { Button, Table } from '../ui'
import * as mwacPropTypes from '../propTypes'
import ComputerSelectionForm from './modals/computer_selection_form'

export default class Computers extends Component {
    static propTypes = {
        appState: React.PropTypes.object,
        crew_uuid: React.PropTypes.string,
        gear: mwacPropTypes.gearWithArrayOf(mwacPropTypes.Computers),
        gearActions: React.PropTypes.object,
        modalActions: React.PropTypes.object,
        personalActions: React.PropTypes.object,
    }

    _showSelectionForm = (computer) => {
        let title = 'Add a new computer'
        let data = {}

        if (computer) {
            title = 'Edit computer'
            data = computer
        }

        this.props.modalActions.showModal({
            component: (
                <ComputerSelectionForm
                    crew_uuid={ this.props.crew_uuid }
                    data={ data }
                />
            ),
            modalProps: {
                allowClose: true,
                title,
            },
        })
    }

    _deleteItem = (item) => {
        this.props.gearActions.deleteComputer(this.props.crew_uuid, item.uuid)
    }

    render() {
        const key = 'computers'
        let data = []

        if (this.props.gear.data && this.props.gear.data[key]) {
            data = this.props.gear.data[key]
        }

        let errors = null

        if (getProperty(this.props.gear.errors, key)) {
            errors = (
                <div className="alert alert--error">
                    { this.props.gear.errors[key].map(
                        (item, index) => <p key={ index }>{ item }</p>
                    ) }
                </div>
            )
        }

        return (
            <div className="content__inner">
                <div className="box">
                    <div className="box__header">
                        <div className="box__title">
                            Computers
                        </div>
                    </div>
                    <div className="box__content box__content--padded">
                        { errors }

                        <Table
                            columns={ [
                                { header: 'Type', key: 'computer_type_verbal' },
                                { header: 'Make', key: 'make_verbal' },
                                { header: 'Model', key: 'model' },
                                { header: 'Year', key: 'year' },
                                { header: 'RAM', key: 'ram_verbal' },
                                { header: 'USB 3?', key: 'usb3', display: Table.boolean },
                                { header: 'Thunderbolt?', key: 'thunderbolt', display: Table.boolean },
                                { header: 'Additional Details', key: 'additional_details', display: Table.nl2br },
                                {
                                    header: '\xa0',
                                    className: 'text-right',
                                    display: Table.deleteButton(this._deleteItem),
                                    key: 'delete',
                                },
                            ] }
                            data={ data }
                            onRowClick={ this._showSelectionForm }
                            responsive="stack"
                        />

                        <Button onClick={ () => this._showSelectionForm() } status="create">
                            Add new computer
                        </Button>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./app/components/gear/computers.js